export const type = [
  [
    { text: '电话退货', value: 1 },
    { text: '在线退货', value: 2 },
    { text: '线下退货', value: 3 }
  ]
]
export const channer = [
  [
    { text: '在线投诉', value: 1 },
    { text: '电话投诉', value: 7 },
    { text: '语音投诉', value: 9 },
    { text: '系统录入', value: 2 },
    { text: '12301', value: 10 }
  ]
]
export const timeType = [
  [{
    'text': '年份',
    'value': '2018',
    'key': 'year',
    children: [
      { 'text': 2018, 'value1': '2018-01-01', 'value2': '2018-12-31' },
      { 'text': 2019, 'value1': '2019-01-01', 'value2': '2019-12-31' }
    ]
  },
  {
    'text': '季度',
    'value': '2',
    'key': 'quarter',
    children: [
      { 'text': '第一季度', 'value1': '01-01', 'value2': '03-31' },
      { 'text': '第二季度', 'value1': '04-01', 'value2': '06-30' },
      { 'text': '第三季度', 'value1': '07-01', 'value2': '09-30' },
      { 'text': '第四季度', 'value1': '10-01', 'value2': '12-31' }
    ]
  },
  {
    'text': '月份',
    'value': '3',
    'key': 'mouth',
    children: [
      { 'text': '1月份', 'value1': '1' },
      { 'text': '2月份', 'value1': '2' },
      { 'text': '3月份', 'value1': '3' },
      { 'text': '4月份', 'value1': '4' },
      { 'text': '5月份', 'value1': '5' },
      { 'text': '6月份', 'value1': '6' },
      { 'text': '7月份', 'value1': '7' },
      { 'text': '8月份', 'value1': '8' },
      { 'text': '9月份', 'value1': '9' },
      { 'text': '10月份', 'value1': '10' },
      { 'text': '11月份', 'value1': '11' },
      { 'text': '12月份', 'value1': '12' }
    ]
  }
  ]
]
export const timeType1 = [
  [
    {
      'text': `2018`,
      'value': `2018`,
      'key': 'year',
      children: [{
        'text': '全年',
        'value1': '01-01',
        'value2': '12-31',
        'key': 'year'
      },
      {
        'text': '季度',
        'value1': `2018-01-01`,
        'value2': `2018-12-31`,
        'key': 'quarter',
        children: [
          { 'text': '一季度', 'value1': '01-03', 'value2': '03-31' },
          { 'text': '二季度', 'value1': '04-01', 'value2': '06-30' },
          { 'text': '三季度', 'value1': '07-01', 'value2': '09-30' },
          { 'text': '四季度', 'value1': '10-01', 'value2': '12-31' }
        ]
      },
      {
        'text': '月份',
        'value1': `2018-01-01`,
        'value2': `2018-12-31`,
        'key': 'moutn',
        children: [
          { 'text': '1月份', 'value1': '1' },
          { 'text': '2月份', 'value1': '2' },
          { 'text': '3月份', 'value1': '3' },
          { 'text': '4月份', 'value1': '4' },
          { 'text': '5月份', 'value1': '5' },
          { 'text': '6月份', 'value1': '6' },
          { 'text': '7月份', 'value1': '7' },
          { 'text': '8月份', 'value1': '8' },
          { 'text': '9月份', 'value1': '9' },
          { 'text': '10月份', 'value1': '10' },
          { 'text': '11月份', 'value1': '11' },
          { 'text': '12月份', 'value1': '12' }
        ]
      }
      ]
    },
    {
      'text': `2019`,
      'value': `2019`,
      'key': 'year',
      children: [{
        'text': '全年',
        'value1': '01-01',
        'value2': '12-31',
        'key': 'year'
      },
      {
        'text': '季度',
        'value1': `2019-01-01`,
        'value2': `2019-12-31`,
        'key': 'quarter',
        children: [
          { 'text': '一季度', 'value1': '01-03', 'value2': '03-31' },
          { 'text': '二季度', 'value1': '04-01', 'value2': '06-30' },
          { 'text': '三季度', 'value1': '07-01', 'value2': '09-30' },
          { 'text': '四季度', 'value1': '10-01', 'value2': '12-31' }
        ]
      },
      {
        'text': '月份',
        'value1': `2019-01-01`,
        'value2': `2019-12-31`,
        'key': 'moutn',
        children: [
          { 'text': '1月份', 'value1': '1' },
          { 'text': '2月份', 'value1': '2' },
          { 'text': '3月份', 'value1': '3' },
          { 'text': '4月份', 'value1': '4' },
          { 'text': '5月份', 'value1': '5' },
          { 'text': '6月份', 'value1': '6' },
          { 'text': '7月份', 'value1': '7' },
          { 'text': '8月份', 'value1': '8' },
          { 'text': '9月份', 'value1': '9' },
          { 'text': '10月份', 'value1': '10' },
          { 'text': '11月份', 'value1': '11' },
          { 'text': '12月份', 'value1': '12' }
        ]
      }
      ]
    },
    {
      'text': `2020`,
      'value': `2020`,
      'key': 'year',
      children: [{
        'text': '全年',
        'value1': '01-01',
        'value2': '12-31',
        'key': 'year'
      },
      {
        'text': '季度',
        'value1': `2020-01-01`,
        'value2': `2020-12-31`,
        'key': 'quarter',
        children: [
          { 'text': '一季度', 'value1': '01-03', 'value2': '03-31' },
          { 'text': '二季度', 'value1': '04-01', 'value2': '06-30' },
          { 'text': '三季度', 'value1': '07-01', 'value2': '09-30' },
          { 'text': '四季度', 'value1': '10-01', 'value2': '12-31' }
        ]
      },
      {
        'text': '月份',
        'value1': `2020-01-01`,
        'value2': `2020-12-31`,
        'key': 'moutn',
        children: [
          { 'text': '1月份', 'value1': '1' },
          { 'text': '2月份', 'value1': '2' },
          { 'text': '3月份', 'value1': '3' },
          { 'text': '4月份', 'value1': '4' },
          { 'text': '5月份', 'value1': '5' },
          { 'text': '6月份', 'value1': '6' },
          { 'text': '7月份', 'value1': '7' },
          { 'text': '8月份', 'value1': '8' },
          { 'text': '9月份', 'value1': '9' },
          { 'text': '10月份', 'value1': '10' },
          { 'text': '11月份', 'value1': '11' },
          { 'text': '12月份', 'value1': '12' }
        ]
      }
      ]
    },
    {
      'text': `2021`,
      'value': `2021`,
      'key': 'year',
      children: [{
        'text': '全年',
        'value1': '01-01',
        'value2': '12-31',
        'key': 'year'
      },
      {
        'text': '季度',
        'value1': `2021-01-01`,
        'value2': `2021-12-31`,
        'key': 'quarter',
        children: [
          { 'text': '一季度', 'value1': '01-03', 'value2': '03-31' },
          { 'text': '二季度', 'value1': '04-01', 'value2': '06-30' },
          { 'text': '三季度', 'value1': '07-01', 'value2': '09-30' },
          { 'text': '四季度', 'value1': '10-01', 'value2': '12-31' }
        ]
      },
      {
        'text': '月份',
        'value1': `2021-01-01`,
        'value2': `2021-12-31`,
        'key': 'moutn',
        children: [
          { 'text': '1月份', 'value1': '1' },
          { 'text': '2月份', 'value1': '2' },
          { 'text': '3月份', 'value1': '3' },
          { 'text': '4月份', 'value1': '4' },
          { 'text': '5月份', 'value1': '5' },
          { 'text': '6月份', 'value1': '6' },
          { 'text': '7月份', 'value1': '7' },
          { 'text': '8月份', 'value1': '8' },
          { 'text': '9月份', 'value1': '9' },
          { 'text': '10月份', 'value1': '10' },
          { 'text': '11月份', 'value1': '11' },
          { 'text': '12月份', 'value1': '12' }
        ]
      }
      ]
    },
    {
      'text': `2022`,
      'value': `2022`,
      'key': 'year',
      children: [{
        'text': '全年',
        'value1': '01-01',
        'value2': '12-31',
        'key': 'year'
      },
      {
        'text': '季度',
        'value1': `2022-01-01`,
        'value2': `2022-12-31`,
        'key': 'quarter',
        children: [
          { 'text': '一季度', 'value1': '01-03', 'value2': '03-31' },
          { 'text': '二季度', 'value1': '04-01', 'value2': '06-30' },
          { 'text': '三季度', 'value1': '07-01', 'value2': '09-30' },
          { 'text': '四季度', 'value1': '10-01', 'value2': '12-31' }
        ]
      },
      {
        'text': '月份',
        'value1': `2022-01-01`,
        'value2': `2022-12-31`,
        'key': 'moutn',
        children: [
          { 'text': '1月份', 'value1': '1' },
          { 'text': '2月份', 'value1': '2' },
          { 'text': '3月份', 'value1': '3' },
          { 'text': '4月份', 'value1': '4' },
          { 'text': '5月份', 'value1': '5' },
          { 'text': '6月份', 'value1': '6' },
          { 'text': '7月份', 'value1': '7' },
          { 'text': '8月份', 'value1': '8' },
          { 'text': '9月份', 'value1': '9' },
          { 'text': '10月份', 'value1': '10' },
          { 'text': '11月份', 'value1': '11' },
          { 'text': '12月份', 'value1': '12' }
        ]
      }
      ]
    }
  ]
]
export const complaintTime = function () {
  const timeArr = []
  const curYear = new Date().getFullYear()
  for (let i = 0; i <= curYear - 2018; i++) {
    timeArr.push(
      {
        'text': `${2018 + i}`,
        'value': `${2018 + i}`,
        'key': 'year',
        children: [{
          'text': '全年',
          'value1': '01-01',
          'value2': '12-31',
          'key': 'year'
        },
        {
          'text': '季度',
          'value1': `${2018 + i}-01-01`,
          'value2': `${2018 + i}-12-31`,
          'key': 'quarter',
          children: [
            { 'text': '一季度', 'value1': '01-03', 'value2': '03-31' },
            { 'text': '二季度', 'value1': '04-01', 'value2': '06-30' },
            { 'text': '三季度', 'value1': '07-01', 'value2': '09-30' },
            { 'text': '四季度', 'value1': '10-01', 'value2': '12-31' }
          ]
        },
        {
          'text': '月份',
          'value1': `${2018 + i}-01-01`,
          'value2': `${2018 + i}-12-31`,
          'key': 'moutn',
          children: [
            { 'text': '1月份', 'value1': '01' },
            { 'text': '2月份', 'value1': '02' },
            { 'text': '3月份', 'value1': '03' },
            { 'text': '4月份', 'value1': '04' },
            { 'text': '5月份', 'value1': '05' },
            { 'text': '6月份', 'value1': '06' },
            { 'text': '7月份', 'value1': '07' },
            { 'text': '8月份', 'value1': '08' },
            { 'text': '9月份', 'value1': '09' },
            { 'text': '10月份', 'value1': '10' },
            { 'text': '11月份', 'value1': '11' },
            { 'text': '12月份', 'value1': '12' }
          ]
        }
        ]
      }
    )
  }
  return [timeArr]
}
export const timeType2 = [
  [{
    'text': '2019',
    'value': '2019',
    'key': 'year',
    children: [{
      'text': '全年',
      'value1': '01-01',
      'value2': '12-31',
      'key': 'year'
    },
    {
      'text': '季度',
      'value1': '2019-01-01',
      'value2': '2019-12-31',
      'key': 'quarter',
      children: [
        // { 'text': '一季度', 'value1': '01-03', 'value2': '03-31' },
        { 'text': '二季度', 'value1': '04-01', 'value2': '06-30' },
        { 'text': '三季度', 'value1': '07-01', 'value2': '09-30' },
        { 'text': '四季度', 'value1': '10-01', 'value2': '12-31' }
      ]
    },
    {
      'text': '月份',
      'value1': '2019-01-01',
      'value2': '2019-12-31',
      'key': 'moutn',
      children: [
        // { 'text': '1月份', 'value1': '1' },
        // { 'text': '2月份', 'value1': '2' },
        // { 'text': '3月份', 'value1': '3' },
        // { 'text': '4月份', 'value1': '4' },
        { 'text': '5月份', 'value1': '5' },
        { 'text': '6月份', 'value1': '6' },
        { 'text': '7月份', 'value1': '7' },
        { 'text': '8月份', 'value1': '8' },
        { 'text': '9月份', 'value1': '9' },
        { 'text': '10月份', 'value1': '10' },
        { 'text': '11月份', 'value1': '11' },
        { 'text': '12月份', 'value1': '12' }
      ]
    }
    ]
  },
  {
    'text': '2020',
    'value': '2020',
    'key': 'year',
    children: [{
      'text': '全年',
      'value1': '01-01',
      'value2': '12-31',
      children: [],
      'key': 'year'
    },
    {
      'text': '季度',
      'value1': '2020-01-01',
      'value2': '2020-12-31',
      'key': 'quarter',
      children: [
        { 'text': '一季度', 'value1': '01-03', 'value2': '03-31' },
        { 'text': '二季度', 'value1': '04-01', 'value2': '06-30' },
        { 'text': '三季度', 'value1': '07-01', 'value2': '09-30' },
        { 'text': '四季度', 'value1': '10-01', 'value2': '12-31' }
      ]
    },
    {
      'text': '月份',
      'value1': '2020-01-01',
      'value2': '2020-12-31',
      'key': 'moutn',
      children: [
        { 'text': '1月份', 'value1': '1' },
        { 'text': '2月份', 'value1': '2' },
        { 'text': '3月份', 'value1': '3' },
        { 'text': '4月份', 'value1': '4' },
        { 'text': '5月份', 'value1': '5' },
        { 'text': '6月份', 'value1': '6' },
        { 'text': '7月份', 'value1': '7' },
        { 'text': '8月份', 'value1': '8' },
        { 'text': '9月份', 'value1': '9' },
        { 'text': '10月份', 'value1': '10' },
        { 'text': '11月份', 'value1': '11' },
        { 'text': '12月份', 'value1': '12' }
      ]
    }
    ]
  },
  {
    'text': '2021',
    'value': '2021',
    'key': 'year',
    children: [{
      'text': '全年',
      'value1': '01-01',
      'value2': '12-31',
      children: [],
      'key': 'year'
    },
    {
      'text': '季度',
      'value1': '2021-01-01',
      'value2': '2021-12-31',
      'key': 'quarter',
      children: [
        { 'text': '一季度', 'value1': '01-03', 'value2': '03-31' },
        { 'text': '二季度', 'value1': '04-01', 'value2': '06-30' },
        { 'text': '三季度', 'value1': '07-01', 'value2': '09-30' },
        { 'text': '四季度', 'value1': '10-01', 'value2': '12-31' }
      ]
    },
    {
      'text': '月份',
      'value1': '2021-01-01',
      'value2': '2021-12-31',
      'key': 'moutn',
      children: [
        { 'text': '1月份', 'value1': '1' },
        { 'text': '2月份', 'value1': '2' },
        { 'text': '3月份', 'value1': '3' },
        { 'text': '4月份', 'value1': '4' },
        { 'text': '5月份', 'value1': '5' },
        { 'text': '6月份', 'value1': '6' },
        { 'text': '7月份', 'value1': '7' },
        { 'text': '8月份', 'value1': '8' },
        { 'text': '9月份', 'value1': '9' },
        { 'text': '10月份', 'value1': '10' },
        { 'text': '11月份', 'value1': '11' },
        { 'text': '12月份', 'value1': '12' }
      ]
    }
    ]
  }

  ]
]
export const appoinmentTime = [
  [{
    'text': '2018',
    'value': '2018',
    'key': 'year',
    children: [{
      'text': '全年',
      'value1': '01-01',
      'value2': '12-31',
      children: [],
      'key': 'year'
    },
    {
      'text': '季度',
      'value1': '2019-01-01',
      'value2': '2019-12-31',
      'key': 'quarter',
      children: [
        { 'text': '一季度', 'value1': '01-01', 'value2': '03-31' },
        { 'text': '二季度', 'value1': '04-01', 'value2': '06-30' },
        { 'text': '三季度', 'value1': '07-01', 'value2': '09-30' },
        { 'text': '四季度', 'value1': '10-01', 'value2': '12-31' }
      ]
    },
    {
      'text': '月份',
      'value1': '2019-01-01',
      'value2': '2019-12-31',
      'key': 'moutn',
      children: [
        { 'text': '1月份', 'value1': '01' },
        { 'text': '2月份', 'value1': '02' },
        { 'text': '3月份', 'value1': '03' },
        { 'text': '4月份', 'value1': '04' },
        { 'text': '5月份', 'value1': '05' },
        { 'text': '6月份', 'value1': '06' },
        { 'text': '7月份', 'value1': '07' },
        { 'text': '8月份', 'value1': '08' },
        { 'text': '9月份', 'value1': '09' },
        { 'text': '10月份', 'value1': '10' },
        { 'text': '11月份', 'value1': '11' },
        { 'text': '12月份', 'value1': '12' }
      ]
    }
    ]
  },
  {
    'text': '2019',
    'value': '2019',
    'key': 'year',
    children: [{
      'text': '全年',
      'value1': '01-01',
      'value2': '12-31',
      children: [],
      'key': 'year'
    },
    {
      'text': '季度',
      'value1': '2019-01-01',
      'value2': '2019-12-31',
      'key': 'quarter',
      children: [
        { 'text': '一季度', 'value1': '01-01', 'value2': '03-31' },
        { 'text': '二季度', 'value1': '04-01', 'value2': '06-30' },
        { 'text': '三季度', 'value1': '07-01', 'value2': '09-30' },
        { 'text': '四季度', 'value1': '10-01', 'value2': '12-31' }
      ]
    },
    {
      'text': '月份',
      'value1': '2019-01-01',
      'value2': '2019-12-31',
      'key': 'moutn',
      children: [
        { 'text': '1月份', 'value1': '01' },
        { 'text': '2月份', 'value1': '02' },
        { 'text': '3月份', 'value1': '03' },
        { 'text': '4月份', 'value1': '04' },
        { 'text': '5月份', 'value1': '05' },
        { 'text': '6月份', 'value1': '06' },
        { 'text': '7月份', 'value1': '07' },
        { 'text': '8月份', 'value1': '08' },
        { 'text': '9月份', 'value1': '09' },
        { 'text': '10月份', 'value1': '10' },
        { 'text': '11月份', 'value1': '11' },
        { 'text': '12月份', 'value1': '12' }
      ]
    }
    ]
  },
  {
    'text': '2020',
    'value': '2020',
    'key': 'year',
    children: [{
      'text': '全年',
      'value1': '01-01',
      'value2': '12-31',
      children: [],
      'key': 'year'
    },
    {
      'text': '季度',
      'value1': '2020-01-01',
      'value2': '2020-12-31',
      'key': 'quarter',
      children: [
        { 'text': '一季度', 'value1': '01-01', 'value2': '03-31' },
        { 'text': '二季度', 'value1': '04-01', 'value2': '06-30' },
        { 'text': '三季度', 'value1': '07-01', 'value2': '09-30' },
        { 'text': '四季度', 'value1': '10-01', 'value2': '12-31' }
      ]
    },
    {
      'text': '月份',
      'value1': '2020-01-01',
      'value2': '2020-12-31',
      'key': 'moutn',
      children: [
        { 'text': '1月份', 'value1': '01' },
        { 'text': '2月份', 'value1': '02' },
        { 'text': '3月份', 'value1': '03' },
        { 'text': '4月份', 'value1': '04' },
        { 'text': '5月份', 'value1': '05' },
        { 'text': '6月份', 'value1': '06' },
        { 'text': '7月份', 'value1': '07' },
        { 'text': '8月份', 'value1': '08' },
        { 'text': '9月份', 'value1': '09' },
        { 'text': '10月份', 'value1': '10' },
        { 'text': '11月份', 'value1': '11' },
        { 'text': '12月份', 'value1': '12' }
      ]
    }
    ]
  },
  {
    'text': '2021',
    'value': '2021',
    'key': 'year',
    children: [{
      'text': '全年',
      'value1': '01-01',
      'value2': '12-31',
      children: [],
      'key': 'year'
    },
    {
      'text': '季度',
      'value1': '2021-01-01',
      'value2': '2021-12-31',
      'key': 'quarter',
      children: [
        { 'text': '一季度', 'value1': '01-01', 'value2': '03-31' },
        { 'text': '二季度', 'value1': '04-01', 'value2': '06-30' },
        { 'text': '三季度', 'value1': '07-01', 'value2': '09-30' },
        { 'text': '四季度', 'value1': '10-01', 'value2': '12-31' }
      ]
    },
    {
      'text': '月份',
      'value1': '2021-01-01',
      'value2': '2021-12-31',
      'key': 'moutn',
      children: [
        { 'text': '1月份', 'value1': '01' },
        { 'text': '2月份', 'value1': '02' },
        { 'text': '3月份', 'value1': '03' },
        { 'text': '4月份', 'value1': '04' },
        { 'text': '5月份', 'value1': '05' },
        { 'text': '6月份', 'value1': '06' },
        { 'text': '7月份', 'value1': '07' },
        { 'text': '8月份', 'value1': '08' },
        { 'text': '9月份', 'value1': '09' },
        { 'text': '10月份', 'value1': '10' },
        { 'text': '11月份', 'value1': '11' },
        { 'text': '12月份', 'value1': '12' }
      ]
    }
    ]
  }

  ]
]
export function formateYear (timeType) {
  let date = new Date()
  let year = date.getFullYear()
  let arr = timeType[0][0].children
  let flag = 0
  for (let i in arr) {
    if (arr[i].text === year) {
      flag = 1;
      // debugger;
    }
  }
  if (flag === 0) {
    arr.push({ 'text': year, 'value': year });
  }
  console.log(arr);
  timeType[0][0].children = arr;
  console.log(timeType);
  return timeType
}
export const stateList = [
  [{
    text: '待回访',
    value: '1',
    children: [
      { 'text': '--', value: '' }
    ]
  },
  {
    text: '已回访',
    value: '10',
    children: [
      { 'text': '所有评价', value: '' },
      { 'text': '非常满意', value: '5' },
      { 'text': '基本满意', value: '3' },
      { 'text': '不满意', value: '1' }
    ]
  },
  {
    text: '全部回访',
    value: '',
    children: [
      { 'text': '--', value: '' }
    ]
  }
  ]
]
    // var d = new Date((new Date()).getFullYear(), this.singleMoutn.trim(), 0)// 获取当月的天数
